import { render, staticRenderFns } from "./CTQList.vue?vue&type=template&id=f56c39e6&"
import script from "./CTQList.vue?vue&type=script&lang=js&"
export * from "./CTQList.vue?vue&type=script&lang=js&"
import style0 from "./CTQList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/declan/code/fourpointzero/portal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib'
installComponents(component, {VSelect})
